// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"8e03ad43","130":"02a31e53","219":"8607969e","423":"4b237a86","518":"771aae5a","612":"8844aa15","613":"34317f62","641":"cf0a4678","787":"18a278e3","815":"4e91e891"}[chunkId] + ".chunk.js";
};